/**
 * Packaging OS — DataTable (Phase 1O-B).
 *
 * Minimal generic table for catalog rows. Token-only styles; logical CSS.
 * Columns are render-functions so the caller picks safe field projections.
 */

import type { ReactNode } from "react";

export interface DataTableColumn<R> {
  key: string;
  header: string;
  render: (row: R) => ReactNode;
}

interface DataTableProps<R> {
  rows: R[];
  columns: DataTableColumn<R>[];
  rowKey: (row: R) => string;
  caption: string;
}

export function DataTable<R>({
  rows,
  columns,
  rowKey,
  caption,
}: DataTableProps<R>): JSX.Element {
  return (
    <div className="po-table-wrap">
      <table className="po-table">
        <caption className="po-visually-hidden">{caption}</caption>
        <thead>
          <tr>
            {columns.map((c) => (
              <th key={c.key} scope="col">
                {c.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={rowKey(row)}>
              {columns.map((c) => (
                <td key={c.key}>{c.render(row)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
